'use strict';

import angular from 'angular';

/**
 * Service pour gérer les données de la vidéothèque
 * Ce service récupère les vidéos de la chaîne YouTube OTFIP
 */
export default angular.module('observatoireApp')
  .service('VideothequeService', ['$http', '$q', function($http, $q) {
    // ID de la chaîne YouTube OTFIP
    const CHANNEL_ID = 'UCjSRtH4s1g60pBx-637UpLQ'; // ID de la chaîne @otfip
    
    // Clé API pour YouTube Data API v3
    // NOTE: Dans un environnement de production, cette clé devrait être sécurisée
    // et idéalement gérée côté serveur pour ne pas être exposée côté client
    const API_KEY = 'AIzaSyCZYNQ751SMXs9FB3G0HBsVhNB2PWKRodU'; // Remplacer par une vraie clé API
    
    // Liste des vidéos favorisées par l'utilisateur
    let favoris = [];
    
    // Tenter de charger les favoris du localStorage
    try {
      const favorisSauvegardes = localStorage.getItem('videotheque.favoris');
      if (favorisSauvegardes) {
        favoris = JSON.parse(favorisSauvegardes);
      }
    } catch (e) {
      console.warn('Impossible de charger les favoris:', e);
    }
    
    // Données des vidéos officielles de la chaîne YouTube @otfip
    // Ces données servent de fallback si l'API YouTube n'est pas disponible
    const videosMockees = [
      {
        videoId: 'IE9aIlgps-A',
        titre: 'PRESENTATION DE VOTRE APPLICATION E-AGENT',
        description: 'Grande annonce ! Nous sommes fiers de vous présenter E-Agent, l\'application qui révolutionne la vie des agents civils de l\'État ! Accès rapide et sécurisé à vos informations administratives.',
        thumbnail: 'https://i.ytimg.com/vi/IE9aIlgps-A/hqdefault.jpg',
        categorie: 'Applications',
        date: '2024-01-15',
        vues: '1.2K',
        duree: '2:30'
      },
      {
        videoId: 'Ao1A9CSQW9g',
        titre: 'تطبيق الوكيل الإلكتروني الخاص بك (E-Agent en Arabe)',
        description: 'إعلان كبير! نحن فخورون بتقديم وكيل إلكتروني، وهو التطبيق الذي يثرية حياة المدنيين. وصول سريع وآمن إلى معلوماتك الإدارية وتبسيط الإجراءات.',
        thumbnail: 'https://i.ytimg.com/vi/Ao1A9CSQW9g/hqdefault.jpg',
        categorie: 'Applications',
        date: '2024-01-15',
        vues: '856',
        duree: '2:30'
      },
      {
        videoId: 'Y8IL8FaVVI8',
        titre: 'Les tendances et les opportunités du secteur agricole',
        description: 'Le secteur agricole joue un rôle essentiel dans l\'économie du Tchad, avec des productions phares comme la gomme arabique, le sésame, l\'arachide et le coton. Analyse des tendances et opportunités.',
        thumbnail: 'https://i.ytimg.com/vi/Y8IL8FaVVI8/hqdefault.jpg',
        categorie: 'Analyses',
        date: '2024-02-20',
        vues: '945',
        duree: '5:45'
      },
      {
        videoId: 'uhZ3lja8s3I',
        titre: 'Note sur le secteur pétrolier n°29',
        description: 'Voici en vidéo, le résumé du n°29 de la note sur le secteur pétrolier. #ObservatoireTchadien #SecteurPetrolier #Tchad #TransparencyInternational #IMF #Glencore',
        thumbnail: 'https://i.ytimg.com/vi/uhZ3lja8s3I/hqdefault.jpg',
        categorie: 'Secteur Pétrolier',
        date: '2024-03-10',
        vues: '723',
        duree: '3:15'
      },
      {
        videoId: 'hW294GtxYPA',
        titre: 'مذكرة قطاع النفط رقم 29 (Note pétrolière n°29 en Arabe)',
        description: 'وفيما يلي ملخص بالفيديو للمذكرة رقم 29 الخاصة بقطاع النفط. #ObservatoireTchadien #SecteurPetrolier #Tchad',
        thumbnail: 'https://i.ytimg.com/vi/hW294GtxYPA/hqdefault.jpg',
        categorie: 'Secteur Pétrolier',
        date: '2024-03-10',
        vues: '512',
        duree: '3:15'
      },
      {
        videoId: 'ESmCCKyMOQM',
        titre: 'مذكرة قطاع النفط رقم 28 (Note pétrolière n°28 en Arabe)',
        description: 'وفيما يلي ملخص بالفيديو للمذكرة رقم 28 الخاصة بقطاع النفط. #ObservatoireTchadien #SecteurPetrolier #Tchad #TransparencyInternational',
        thumbnail: 'https://i.ytimg.com/vi/ESmCCKyMOQM/hqdefault.jpg',
        categorie: 'Secteur Pétrolier',
        date: '2024-02-15',
        vues: '634',
        duree: '3:00'
      }
    ];
    
    /**
     * Récupère les vidéos de la chaîne YouTube OTFIP
     * @returns {Promise} Promesse contenant les données des vidéos
     */
    this.getVideos = function() {
      // Utiliser l'API YouTube pour récupérer les vidéos de la chaîne
      const forceRealApi = true; // Activé pour utiliser l'API YouTube avec le channel_id
      
      // Si mode développement ou problème d'API, utiliser les données mockées
      if (!forceRealApi) {
        console.log('Utilisation des données mockées en raison des problèmes avec l\'API YouTube');
        return loadMockData();
      }
      
      // Tentative d'appel réel à l'API YouTube
      console.log('Tentative d\'appel à l\'API YouTube avec:', { 
        channelId: CHANNEL_ID, 
        apiKey: API_KEY ? 'Définie' : 'Non définie' 
      });
      
      // ⚠️ NOTE: L'API YouTube renvoie actuellement une erreur 403 Forbidden
      // La clé API a probablement expiré, est invalide ou a atteint son quota
      // Nous allons gérer cette erreur et utiliser les données mockées comme fallback
      
      const apiUrl = `https://www.googleapis.com/youtube/v3/search?key=${API_KEY}&channelId=${CHANNEL_ID}&part=snippet,id&order=date&maxResults=50`;

      return $http.get(apiUrl)
        .then(function(response) {
          console.log('Réponse de l\'API YouTube reçue:', {
            status: response.status,
            statusText: response.statusText,
            hasData: !!response.data,
            hasItems: response.data && !!response.data.items,
            itemCount: response.data && response.data.items ? response.data.items.length : 0
          });
          
          if (response.data && response.data.items && response.data.items.length > 0) {
            // Transformer les données de l'API en format plus simple
            // Filtrer pour ne garder que les items de type video (pas playlists/chaines)
            var videosBasic = response.data.items.filter(function(item) {
                var isVideo = item.id && item.id.kind === 'youtube#video' && item.id.videoId;
                if (!isVideo) {
                  console.log('Item filtré car ce n\'est pas une vidéo:', item.id);
                }
                return isVideo;
              });
              
            console.log('Vidéos filtrées:', videosBasic.length, 'sur', response.data.items.length);
            
            // Créer une liste basique des vidéos
            var videos = videosBasic.map(function(item) {
                return {
                  videoId: item.id.videoId,
                  titre: item.snippet.title,
                  description: item.snippet.description,
                  thumbnail: item.snippet.thumbnails.high ? item.snippet.thumbnails.high.url : 
                            (item.snippet.thumbnails.medium ? item.snippet.thumbnails.medium.url : 
                             item.snippet.thumbnails.default.url),
                  date: new Date(item.snippet.publishedAt).toISOString().split('T')[0],
                  categorie: assignerCategorie(item.snippet.title, item.snippet.description),
                  vues: 'N/A', // Sera rempli par l'appel à l'API Videos
                  duree: 'N/A',  // Sera rempli par l'appel à l'API Videos
                  downloadable: true // Toutes les vidéos de la chaîne sont téléchargeables
                };
            });
            
            // Si pas de vidéos trouvées, on utilise les données mockées
            if (videos.length === 0) {
              console.warn('Aucune vidéo trouvée dans le canal spécifié, utilisation des données mockées');
              return loadMockData();
            }
            
            // Récupérer les détails supplémentaires via l'API Videos
            // Extraire tous les IDs de vidéos pour l'appel groupé
            var videoIds = videos.map(function(video) {
              return video.videoId;
            }).join(',');
            
            // Appel à l'API Videos pour obtenir les détails
            var detailsUrl = `https://www.googleapis.com/youtube/v3/videos?key=${API_KEY}&id=${videoIds}&part=statistics,contentDetails`;
            
            return $http.get(detailsUrl).then(function(detailsResponse) {
              if (detailsResponse.data && detailsResponse.data.items) {
                // Pour chaque vidéo dans notre liste, trouver et ajouter les détails
                videos.forEach(function(video) {
                  var details = detailsResponse.data.items.find(function(item) {
                    return item.id === video.videoId;
                  });
                  
                  if (details) {
                    // Ajouter les statistiques (vues, likes, etc.)
                    if (details.statistics) {
                      video.vues = formatNumber(details.statistics.viewCount || '0');
                    }
                    
                    // Ajouter la durée au format lisible
                    if (details.contentDetails && details.contentDetails.duration) {
                      video.duree = formatDuration(details.contentDetails.duration);
                    }
                  }
                });
              }
              
              console.log('Vidéos récupérées avec détails depuis l\'API YouTube:', videos.length);
              return videos;
            }).catch(function(error) {
              console.warn('Erreur lors de la récupération des détails, retour des vidéos sans détails:', error);
              return videos; // Retourner les vidéos sans détails en cas d'erreur
            });
          } else {
            console.warn('Données API invalides ou canal sans vidéos, utilisation des données mockées');
            return loadMockData();
          }
        })
        .catch(function(error) {
          console.error('Erreur lors de l\'appel à l\'API YouTube:', error);
          if (error.status === 403) {
            console.error('Erreur d\'autorisation (403) - Vérifiez que votre clé API est valide et active pour YouTube Data API v3');
          } else if (error.status === 404) {
            console.error('Erreur 404 - Canal YouTube non trouvé. Vérifiez l\'ID du canal:', CHANNEL_ID);
          }
          console.warn('Utilisation des données mockées comme fallback');
          // En cas d'erreur, utiliser des données mockées comme fallback
          return loadMockData();
        });
      
      // Fonction pour charger les données mockées
      function loadMockData() {
        const deferred = $q.defer();
        
        setTimeout(function() {
          deferred.resolve(videosMockees);
        }, 800); // Délai simulé de 800ms
        
        return deferred.promise;
      }
    };
    
    /**
     * Fonction auxiliaire pour assigner une catégorie à une vidéo
     * basée sur son titre et sa description
     * @param {string} titre - Titre de la vidéo
     * @param {string} description - Description de la vidéo
     * @returns {string} - Catégorie assignée
     */
    function assignerCategorie(titre, description) {
      const contenu = (titre + ' ' + description).toLowerCase();
      
      if (contenu.includes('conférence')) return 'Conférences';
      if (contenu.includes('formation') || contenu.includes('atelier')) return 'Formation';
      if (contenu.includes('débat') || contenu.includes('table ronde') || contenu.includes('panel')) return 'Débats';
      if (contenu.includes('interview') || contenu.includes('entretien')) return 'Interviews';
      if (contenu.includes('rapport') || contenu.includes('presentation')) return 'Rapports';
      if (contenu.includes('analyse') || contenu.includes('étude')) return 'Analyses';
      if (contenu.includes('partenaire') || contenu.includes('réunion')) return 'Partenariats';
      if (contenu.includes('projet') || contenu.includes('programme') || contenu.includes('lancement')) return 'Projets';
      
      return 'Divers';
    }
    
    /**
     * Récupère les détails d'une vidéo spécifique
     * @param {string} videoId - Identifiant YouTube de la vidéo
     * @returns {Promise} Promesse contenant les détails de la vidéo
     */
    this.getVideoDetails = function(videoId) {
      // En production, utilisez ce code pour faire un appel réel à l'API YouTube
      /*
      const apiUrl = `https://www.googleapis.com/youtube/v3/videos?key=${API_KEY}&id=${videoId}&part=snippet,statistics,contentDetails`;
      
      return $http.get(apiUrl)
        .then(function(response) {
          if (response.data && response.data.items && response.data.items.length > 0) {
            const videoData = response.data.items[0];
            return {
              videoId: videoData.id,
              titre: videoData.snippet.title,
              description: videoData.snippet.description,
              thumbnail: videoData.snippet.thumbnails.high.url,
              date: new Date(videoData.snippet.publishedAt).toISOString().split('T')[0],
              vues: videoData.statistics.viewCount,
              likes: videoData.statistics.likeCount,
              categorie: assignerCategorie(videoData.snippet.title, videoData.snippet.description),
              duree: formatDuration(videoData.contentDetails.duration)
            };
          } else {
            return $q.reject('Vidéo non trouvée');
          }
        });
      */
      
      // Pour le développement, rechercher dans les données mockées
      const deferred = $q.defer();
      
      setTimeout(function() {
        const video = videosMockees.find(function(v) {
          return v.videoId === videoId;
        });
        
        if (video) {
          deferred.resolve(video);
        } else {
          deferred.reject('Vidéo non trouvée');
        }
      }, 500);
      
      return deferred.promise;
    };
    
    /**
     * Formate un nombre pour l'affichage (ex: 1234567 -> 1 234 567 ou 1.2M selon la locale)
     * @param {string} numberStr - Nombre sous forme de chaîne
     * @returns {string} - Nombre formaté
     */
    function formatNumber(numberStr) {
      const num = parseInt(numberStr, 10);
      if (isNaN(num)) return '0';
      
      // Si le nombre est supérieur à 1 million, format en M
      if (num >= 1000000) {
        return (num / 1000000).toFixed(1) + 'M';
      } 
      // Si le nombre est supérieur à 1000, format en K
      else if (num >= 1000) {
        return (num / 1000).toFixed(1) + 'K';
      } 
      // Sinon retour le nombre avec séparateurs
      else {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      }
    }
    
    /**
     * Formate la durée ISO 8601 en format lisible
     * @param {string} isoDuration - Durée au format ISO 8601 (PT1H30M15S)
     * @returns {string} - Durée formatée (1:30:15)
     */
    function formatDuration(isoDuration) {
      const match = isoDuration.match(/PT(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?/);
      
      if (!match) return '00:00';
      
      const hours = match[1] ? parseInt(match[1], 10) : 0;
      const minutes = match[2] ? parseInt(match[2], 10) : 0;
      const seconds = match[3] ? parseInt(match[3], 10) : 0;
      
      if (hours > 0) {
        return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      } else {
        return `${minutes}:${seconds.toString().padStart(2, '0')}`;
      }
    }
    
    /**
     * Vérifie si une vidéo est dans les favoris
     * @param {string} videoId - ID de la vidéo à vérifier
     * @returns {boolean} - True si la vidéo est en favori
     */
    this.estFavori = function(videoId) {
      return favoris.includes(videoId);
    };
    
    /**
     * Ajoute ou supprime une vidéo des favoris
     * @param {string} videoId - ID de la vidéo à basculer
     * @returns {boolean} - Nouvel état (true si ajouté aux favoris, false si retiré)
     */
    this.toggleFavori = function(videoId) {
      const index = favoris.indexOf(videoId);
      
      if (index === -1) {
        // Ajouter aux favoris
        favoris.push(videoId);
        this.sauvegarderFavoris();
        return true;
      } else {
        // Retirer des favoris
        favoris.splice(index, 1);
        this.sauvegarderFavoris();
        return false;
      }
    };
    
    /**
     * Sauvegarde les favoris dans le localStorage
     */
    this.sauvegarderFavoris = function() {
      try {
        localStorage.setItem('videotheque.favoris', JSON.stringify(favoris));
      } catch (e) {
        console.warn('Impossible de sauvegarder les favoris:', e);
      }
    };
    
    /**
     * Récupère la liste des vidéos favorites
     * @returns {Promise} - Promesse contenant les vidéos favorites
     */
    this.getVideosFavorites = function() {
      return this.getVideos().then(function(videos) {
        return videos.filter(function(video) {
          return favoris.includes(video.videoId);
        });
      });
    };
    
    /**
     * Prépare le téléchargement d'une vidéo
     * @param {Object} video - La vidéo à télécharger
     */
    this.telechargerVideo = function(video) {
      // Dans un environnement réel, on pourrait rediriger vers une API de téléchargement
      // ou utiliser une bibliothèque comme file-saver pour gérer le téléchargement
      
      // Pour cette démonstration, nous ouvrons simplement un lien de téléchargement
      const lienTelecharger = `https://www.ssyoutube.com/watch?v=${video.videoId}`;
      window.open(lienTelecharger, '_blank');
      
      // Enregistrer l'activité de téléchargement
      console.log(`Téléchargement demandé pour la vidéo: ${video.titre} (ID: ${video.videoId})`);
    };
  }]);
